import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _create_class from "@swc/helpers/src/_create_class.mjs";
import _get from "@swc/helpers/src/_get.mjs";
import _get_prototype_of from "@swc/helpers/src/_get_prototype_of.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import { currencyEquals } from "../token";
import { ETHER } from "../currency";
import invariant from "tiny-invariant";
import JSBI from "jsbi";
import _Big from "big.js";
import toFormat from "toformat";
import { Rounding, TEN, SolidityType } from "../../constants";
import { parseBigintIsh, validateSolidityTypeInstance } from "../../utils";
import { Fraction } from "./fraction";
var Big = toFormat(_Big);
export var CurrencyAmount = /*#__PURE__*/ function(Fraction) {
    "use strict";
    _inherits(CurrencyAmount, Fraction);
    var _super = _create_super(CurrencyAmount);
    function CurrencyAmount(currency, amount) {
        _class_call_check(this, CurrencyAmount);
        var _this;
        var parsedAmount = parseBigintIsh(amount);
        validateSolidityTypeInstance(parsedAmount, SolidityType.uint256);
        _this = _super.call(this, parsedAmount, JSBI.exponentiate(TEN, JSBI.BigInt(currency.decimals)));
        _this.currency = currency;
        return _this;
    }
    var _proto = CurrencyAmount.prototype;
    _proto.add = function add(other) {
        invariant(currencyEquals(this.currency, other.currency), "TOKEN");
        return new CurrencyAmount(this.currency, JSBI.add(this.raw, other.raw));
    };
    _proto.subtract = function subtract(other) {
        invariant(currencyEquals(this.currency, other.currency), "TOKEN");
        return new CurrencyAmount(this.currency, JSBI.subtract(this.raw, other.raw));
    };
    _proto.toSignificant = function toSignificant() {
        var significantDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 6, format = arguments.length > 1 ? arguments[1] : void 0, rounding = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Rounding.ROUND_DOWN;
        return _get(_get_prototype_of(CurrencyAmount.prototype), "toSignificant", this).call(this, significantDigits, format, rounding);
    };
    _proto.toFixed = function toFixed() {
        var decimalPlaces = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.currency.decimals, format = arguments.length > 1 ? arguments[1] : void 0, rounding = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Rounding.ROUND_DOWN;
        invariant(decimalPlaces <= this.currency.decimals, "DECIMALS");
        return _get(_get_prototype_of(CurrencyAmount.prototype), "toFixed", this).call(this, decimalPlaces, format, rounding);
    };
    _proto.toExact = function toExact() {
        var format = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            groupSeparator: ""
        };
        Big.DP = this.currency.decimals;
        return new Big(this.numerator.toString()).div(this.denominator.toString()).toFormat(format);
    };
    /**
   * Helper that calls the constructor with the ETHER currency
   * @param amount ether amount in wei
   */ CurrencyAmount.ether = function ether(amount) {
        return new CurrencyAmount(ETHER, amount);
    };
    _create_class(CurrencyAmount, [
        {
            key: "raw",
            get: function get() {
                return this.numerator;
            }
        }
    ]);
    return CurrencyAmount;
}(Fraction);
